import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
    COMAIChatButtonText,
    COMAIChatDescription,
    COMAIChatHeadline
} from 'autogen/translation-keys/trans-website-chat';
import useDrawer from 'components/generic/Drawer/hooks/useDrawer';
import ChatAgentOption from '../components/ChatAgentOption';
import ComAIDrawerView from './components/ComAIDrawerView';
import FeedBackDrawer from './components/FeedbackDrawer';
import TermsAndConditionsDrawer from './components/TermsAndConditionsDrawer';
import { COM_AI_DRAWER_ID, COM_AI_FEEDBACK_DRAWER_ID, COM_AI_TERMS_DRAWER_ID } from './shared/consts';
import useComAIStore from './store/comAIStore';

const ChatAgentOptionComAI = () => {
    const comAIDrawer = useDrawer(COM_AI_DRAWER_ID, { disableOverlay: true });
    const comAITermsDrawer = useDrawer(COM_AI_TERMS_DRAWER_ID, { disableOverlay: true });
    const hasAcceptedTerms = useComAIStore((state) => state.hasAcceptedTerms);

    const { t } = useTranslation();

    const open = useCallback(() => {
        if (!hasAcceptedTerms) {
            comAITermsDrawer.open();
            return;
        }

        comAIDrawer.open();
    }, [comAIDrawer.open, comAITermsDrawer.open, hasAcceptedTerms]);

    return (
        <>
            <ChatAgentOption
                title={t(COMAIChatHeadline)}
                description={t(COMAIChatDescription)}
                buttonText={t(COMAIChatButtonText)}
                icon="AI"
                open={open}
            />
            <TermsAndConditionsDrawer drawerId={COM_AI_TERMS_DRAWER_ID} />
            <ComAIDrawerView drawerId={COM_AI_DRAWER_ID} />
            <FeedBackDrawer drawerId={COM_AI_FEEDBACK_DRAWER_ID} />
        </>
    );
};

export default ChatAgentOptionComAI;
